export enum ScoreCardFileType  {
  GOOGLE = 'Google Sheet',
  EXCEL = 'Excel',
}